import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Accordion, Table, Loader, Popup, Icon} from 'semantic-ui-react';
import _ from 'lodash';
import {Actions} from '../../../../../common/actions';
import {
  resources,
  scopes,
} from '../../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../../common/permissions/validations';
import BinPendingModal from '../modals/binPending';
import ReservationsModal from '../modals/reservations';

class StockTde extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeIndex': '',
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const {code} = this.props;
    this.props.fetchWarehouseStockDetail(code);
  }

  componentDidUpdate(prevProps) {
    const {code} = this.props;
    if (code !== prevProps.code) {
      this.props.fetchWarehouseStockDetail(code);
    }
  }

  handleClick = (e, titleProps) => {
    const {activeIndex} = this.state;
    const {index} = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({'activeIndex': newIndex});
  };

  renderKardexOption(warehouse) {
    if (
      !hasAccessPermission(this.props.permissions, resources.Kardex, scopes.See)
    ) {
      return null;
    }
    const {code} = this.props;
    return (
      <Table.Cell textAlign='center'>
        <Popup
          trigger={
            <Link to={`/partes/consultas/ver/${code}/kardex/${warehouse}`}>
              <Icon name='credit card' size='large' />
            </Link>
          }
          content='Kardex'
          position='top center'
          inverted
        />
      </Table.Cell>
    );
  }

  renderItems() {
    const {warehouseStockData} = this.props;
    if (warehouseStockData.length === 0) {
      return (
        <Table.Row key={0}>
          <Table.Cell colSpan={8} textAlign='center'>
            No hay datos disponibles
          </Table.Cell>
        </Table.Row>
      );
    }
    const {code} = this.props;
    return warehouseStockData.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.warehouse}</Table.Cell>
          <Table.Cell textAlign='right'>
            {element.stockJde.toLocaleString()}
          </Table.Cell>
          <Table.Cell textAlign='right'>
            {element.stockScb.toLocaleString()}
          </Table.Cell>
          <Table.Cell textAlign='right'>
            <BinPendingModal code={code} quantity={element.binPending} />
          </Table.Cell>
          <Table.Cell
            textAlign='right'
            style={{'color': element.differences >= 0 ? 'green' : 'red'}}
          >
            {element.differences}
          </Table.Cell>
          <Table.Cell textAlign='right'>
            <ReservationsModal code={code} quantity={element.reserved} />
          </Table.Cell>
          <Table.Cell textAlign='right'>{element.available}</Table.Cell>
          {this.renderKardexOption(element.warehouse)}
        </Table.Row>
      );
    });
  }

  renderTotalStock(cpdData) {
    const {loading} = this.props;

    if (loading) {
      return (
        <span className='quantity-container'>
          <Loader active size='tiny' inline />
        </span>
      );
    }

    return (
      <span className='quantity-container'>
        {cpdData && cpdData.stockScb ? cpdData.stockScb.toLocaleString() : 0}
      </span>
    );
  }

  renderData() {
    const {loading} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderItems();
  }

  render() {
    const {activeIndex} = this.state;
    const {warehouseStockData} = this.props;

    const cpdData = _.find(warehouseStockData, function(o) {
      return o.warehouse === 'CPD';
    });

    return (
      <Accordion fluid>
        <Accordion.Title
          active={activeIndex === 0}
          index={0}
          onClick={this.handleClick}
        >
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell colSpan={6} textAlign='left'>
                  Existencia TDE (On Hand)
                  {this.renderTotalStock(cpdData)}
                </Table.HeaderCell>
                <Table.HeaderCell colSpan={1} textAlign='right'>
                  <Icon name='dropdown' />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
          </Table>
        </Accordion.Title>

        <Accordion.Content active={activeIndex === 0}>
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>Bodega</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Existencia JDE
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Existencia TEMS
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Pendiente Binning
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Diferencias
                  <Popup
                    trigger={
                      <Icon link name='info circle' color='blue' size='large' />
                    }
                    on='click'
                    position='bottom left'
                    inverted
                  >
                    <div>
                      Fórmula utilizada: Existencia JDE - (Existencia SCB +
                      Pendiente Binning)
                    </div>
                  </Popup>
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Reservado
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Disponible
                </Table.HeaderCell>
                {hasAccessPermission(
                  this.props.permissions,
                  resources.Kardex,
                  scopes.See
                ) && (
                  <Table.HeaderCell textAlign='center'>Kardex</Table.HeaderCell>
                )}
              </Table.Row>
            </Table.Header>

            <Table.Body>{this.renderData()}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.partModals.loadingWarehouseStockDetail,
    'warehouseStockData': state.partModals.warehouseStockDetail,
    'permissions': state.session.permissions,
  };
};

const {fetchWarehouseStockDetail} = Actions;

export default connect(mapStateToProps, {
  fetchWarehouseStockDetail,
})(StockTde);
